import { Action } from '@ngrx/store';

import { Subscription } from './subscriptions.model';

export const /** @type {?} */ LOAD_SUBSCRIPTION = '[subscription] LOAD_SUBSCRIPTION';
export const /** @type {?} */ LOAD_SUBSCRIPTION_SUCCESS = '[subscription] LOAD_SUBSCRIPTION_SUCCESS';
export const /** @type {?} */ LOAD_SUBSCRIPTION_FAILURE = '[subscription] LOAD_SUBSCRIPTION_FAILURE';
export class LoadSubscription implements Action {
    readonly type = LOAD_SUBSCRIPTION;
}

function LoadSubscription_tsickle_Closure_declarations() {
/** @type {?} */
LoadSubscription.prototype.type;
}

export class LoadSubscriptionSuccess implements Action {
    readonly type = LOAD_SUBSCRIPTION_SUCCESS;
/**
 * @param {?=} payload
 */
constructor(public payload?: any) {
    }
}

function LoadSubscriptionSuccess_tsickle_Closure_declarations() {
/** @type {?} */
LoadSubscriptionSuccess.prototype.type;
/** @type {?} */
LoadSubscriptionSuccess.prototype.payload;
}

export class LoadSubscriptionFailure implements Action {
    readonly type = LOAD_SUBSCRIPTION_FAILURE;
/**
 * @param {?=} payload
 */
constructor(public payload?: any) {
    }
}

function LoadSubscriptionFailure_tsickle_Closure_declarations() {
/** @type {?} */
LoadSubscriptionFailure.prototype.type;
/** @type {?} */
LoadSubscriptionFailure.prototype.payload;
}



export type Actions
    = LoadSubscription
    | LoadSubscriptionSuccess
    | LoadSubscriptionFailure;
